import React, { Component } from 'react';
import config from '../config';
import '../css/navBar.css';
import '../css/responsive.css';
import { FORMAT_NUMBER, CURRENCY, development, FINISH_THE_RACE, F1_GRILL, CHATBOT_URL, Modules, Sections, sellTypeSelect, decodeText } from '../libs/utils/Const';
import packageJson from '../../package.json';
import moment from 'moment';
import { NotificationCenter } from './index';
import socketService from '../libs/sockets/SocketService';
import printerService from '../libs/printer/PrinterService';
global.appVersion = packageJson.version;
const currentVersion = global.appVersion;
const CryptoJS = require("crypto-js");

class NavBarCashier extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPerception: false,
            printerConnected: printerService.isConnected()
        };
    }

    logOut = () => {
        const { props } = this.props;
        localStorage.removeItem(config.localStorageNamed + 'Token');
        localStorage.removeItem(config.localStorageNamed + 'currentUser');
        localStorage.removeItem(config.localStorageNamed + 'toogleNavBarItem');
        socketService.emit('logout', '');
        props.history.push('/login');
    }

    componentDidMount = async () => {
        const { props, newOrderModel, ChangeObjectype, CounterRol } = this.props;
        let token = await FINISH_THE_RACE(localStorage.getItem(config.localStorageNamed + 'Token'), F1_GRILL.CHECO_PEREZ);

        if (CounterRol === 'counter') {
            ChangeObjectype(newOrderModel, "deliveries4", false)
        }
        if (!token) {
            props.history.push('/login');
            return;
        }

        this.componentIsMounted = true;
        this.unsubscribePrinterConnection = printerService.subscribeConnection((printerConnected) => {
            if (this.componentIsMounted) this.setState({ printerConnected });
        });
        printerService.connectConfiguredPrinter(this.props._user);

        // this.importChat();
    }

    componentWillUnmount() {
        this.componentIsMounted = false;
        if (this.unsubscribePrinterConnection) this.unsubscribePrinterConnection();
    }

    importChat = () => {
        // Crea el script del chat
        const chat = document.createElement('script');
        chat.src = CHATBOT_URL;
        chat.async = true;
        chat.setAttribute('chat', 'true');
        document.body.appendChild(chat);

        // Para no mostrar el boton del chat
        const hideChatButton = document.createElement('script');
        hideChatButton.innerHTML = `
        window.fcWidgetMessengerConfig = {
            config: {
            headerProperty: {
                hideChatButton: true,
            }
            }
        };
        `;
        document.body.appendChild(hideChatButton);
    }

    openChatWidget = () => {
        if (window.fcWidget) {
            window.fcWidget.open();
        }
    };

    renderUserName = () => {
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        if (!user) {
            return "";
        }
        return user.U_NAME || "";
    };

    openTicketRef(CreateDocument) {
        CreateDocument();

    }

    //#region ########## redirect ###################
    openLink = (link) => {
        const { props } = this.props;
        props.history.push(link);
    }
    //#endregion

    render() {
        const {
            newOrderModel,
            itemSearch,
            ChangeSearchItem,
            SearchItems,
            ShowRefundModal,
            ShowCashCutModal,
            ShowSavedSalesModal,
            ShowSearchModal,
            EnableClientsModal,
            GetMovementsCash,
            ChangeObjectype,
            ShowTaxesModal,
            ShowRefSaleModal,
            ShowBeforeExit,
            ChangePriceList,
            ChangeIconSaveSale,
            _user,
            SendInvoiceValidation,
            SendReserveInvoice,
            CheckIfItems,
            ValidateBusinessPartner,
            ShowVMQuotation,
            OrderValidation,
            CounterRol,
            ShowDeleteAll,
            DisableRecover,
            DisableRecoverQT,
            ShowAdvancePayment,
            ChangeCreditCheck,
            ShowDeliverModal,
            GetReportSalesPayments,
            CheckTerminalConnection,
            recoveredQuoteOperation,
            validateCasco,
            handedCasco,
            globalTax,
            EditTaxCode,
            sellType,
            wareHouseTransaction,
            ShowPrinterConfiguration,
            ReprintLastTicket,
        } = this.props;
        const { showPerception, printerConnected } = this.state;
        const vta = sellTypeSelect.find(vta => vta.value == sellType)
        let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        let bytes = CryptoJS.AES.decrypt(itemsDashboard, 'exchange');
        itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return (
            <div className="div-nav nav-cashier-web">
                {/* NAV BAR */}
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark" id="navTop">
                    <div className="hamburger">
                        <div className="cta">
                            <div className=" type14">
                                <span className="fa fa-reply btn" aria-hidden="true" style={{ color: "white", fontSize: "30px" }} data-toggle="modal" data-target="#vmBeforeExit" onClick={ShowBeforeExit}>
                                    { }
                                </span>
                            </div>
                        </div>
                    </div>

                    <a href=" " className="navbar-brand cursor-pointer" >
                        <img src={require('../images/logocounter.png')} className="image" alt="COUNTER ONE" />
                    </a>
                    {!development && <span className="navbar-brand cursor-pointer" style={{ background: "white", borderRadius: "8px", margin: "1rem" }}>
                        <img src={require('../images/logo_EMPRESA.svg')} alt="Logo" style={{ width: '110px' }} className="logo" />
                    </span>}

                    {development &&
                        <div style={{ background: "red", borderRadius: "8px", margin: "1rem" }}>
                            <h4 className='pt-1 ml-2 mr-2' style={{ color: "white" }}>AMBIENTE DE PRUEBAS</h4>
                        </div>}
                    {sellType && (
                        <div className="d-flex flex-column">
                            <div className="input-group-prepend mb-1">
                                <label
                                    className="input-group-text"
                                    id="lblTipoVta"
                                    style={{
                                        backgroundColor: "#343a40",
                                        color: "white",
                                        border: "none",
                                        fontSize: 18
                                    }}
                                >
                                    <strong>{`Venta ${vta?.prefix || ''} ${vta?.tipoVta || ''}`}</strong>
                                </label>
                            </div>

                            {wareHouseTransaction && (
                                <div className="input-group-prepend">
                                    <label
                                        className="input-group-text"
                                        style={{
                                            backgroundColor: "#343a40",
                                            color: "white",
                                            border: "none",
                                            fontSize: 10
                                        }}
                                    >
                                        <strong>{`| ${wareHouseTransaction?.WhsCode} - ${decodeText(wareHouseTransaction?.WhsName)}`}</strong>
                                    </label>
                                </div>
                            )}
                        </div>
                    )}


                    <div className='m-auto'>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <label className="input-group-text" for="inputGroupSelect01" style={{ backgroundColor: "#343a40", color: "white", border: "none", fontSize: 18 }}>Operación:</label>
                            </div>
                            <select
                                className="form-control text-center cursor-pointer"
                                disabled={DisableRecover}
                                style={{ backgroundColor: "#343a40", color: "white", border: "none", fontWeight: 'bold', fontSize: 18 }}
                                value={newOrderModel.ObjType}
                                onChange={(event) => { ChangeObjectype(newOrderModel, event.target.value, false) }}>
                                {CounterRol && CounterRol !== null &&
                                    <>
                                        {(CounterRol === 'manager' || CounterRol === 'cashRegister') &&
                                            <option value="deliveries">VENTA</option>
                                        }
                                        {(CounterRol === 'manager' || CounterRol === 'cashRegister' || CounterRol === 'counter') &&
                                            <option value="deliveries2">VENTA A DOMICILIO</option>
                                        }
                                        {(CounterRol === 'manager' || CounterRol === 'counter') &&
                                            <option value="deliveries4">MOSTRADOR</option>
                                        }
                                        {(CounterRol === 'manager' || CounterRol === 'cashRegister' || CounterRol === 'storer' || CounterRol === 'counter') &&
                                            <option value="quotations">COTIZACIÓN</option>
                                        }
                                        {(CounterRol === 'manager' || CounterRol === 'cashRegister' || CounterRol === 'storer' || CounterRol === 'counter') &&
                                            <option value="orderSales">PEDIDO</option>
                                        }
                                        {(CounterRol === 'manager' || CounterRol === 'cashRegister') &&
                                            <option value="invoiceReserve">FACTURA DE RESERVA</option>
                                        }
                                        {/* {(CounterRol === 'manager' || CounterRol === 'cashRegister') &&
                                            <option value="creditNote">NOTA DE CRÉDITO</option>
                                        } */}

                                        {/* {(CounterRol === 'manager' || CounterRol === 'cashRegister') &&
                                            <option value="directDelivery">ENTREGA DIRECTA</option>
                                        } */}
                                        {(CounterRol === 'manager' || CounterRol === 'cashRegister') &&
                                            <option value="downPayments">FACTURA DE ANTICIPO</option>
                                        }
                                    </>
                                }
                            </select>
                        </div>
                    </div>
                    <ul className="right navBarr">
                        <li className="nav-item user">
                            <NotificationCenter />
                        </li>
                        <li className="nav-item user" style={{ fontSize: 17, fontWeight: 'bold' }}>
                            <button type="button" className="btn" disabled style={{ color: 'white', fontSize: 17 }}>
                                <i className="fas fa-user" aria-hidden="true" />
                                <span className='text-white'>&nbsp; {this.renderUserName()}</span>
                            </button>
                        </li>
                        <li className="nav-item user" style={{ fontSize: 17, fontWeight: 'bold' }}>
                            <button type="button" className="btn" style={{ color: 'white', fontSize: 17 }}
                                onClick={this.logOut}>Cerrar Sesión  &nbsp; <i className="fas fa-sign-out-alt"></i>
                            </button>
                        </li>
                    </ul>
                </nav>

                <div className="ml-1 row" style={{ background: "white" }}>
                    <div className="form-group mt-2 col-3 cursor-pointer ">
                        {newOrderModel.ObjType === 'deliveries' &&
                            <div className='ml-1 mt-2' data-toggle="modal" data-target="#vmSaveSale">
                                <div className='d-flex justify-content-start align-items-center'>
                                    <i id="saveSale" className="fa fa-bookmark-o notSaved" aria-hidden="true" style={{ fontSize: 40 }} onClick={() => ChangeIconSaveSale(true)}></i>
                                    {/* <i className="fa fa-comment-o ml-4" aria-hidden="true" style={{ fontSize: 40, color: '#343a4038'}} onClick={this.openChatWidget}></i> */}
                                </div>
                            </div>
                        }
                    </div>

                    {/* BÚSQUEDA ARTÍCULO */}
                    <div className="col-5 mt-2">
                        <div className="input-group m-2">
                            <div className="input-group-prepend" data-toggle="modal" data-target="#searchModal" onClick={DisableRecover ? () => { } : ShowSearchModal}>
                                <span className="input-group-text  btn-outline-secondary " id="basic-addon1"  >
                                    <i className="fa fa-barcode" aria-hidden="true"></i>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control btn-outline"
                                placeholder="Inserte el código o nombre del artículo"
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                value={itemSearch || ''}
                                disabled={DisableRecover}
                                onChange={(event) => { ChangeSearchItem(event.nativeEvent.target.value) }}
                                onKeyPress={(event) => { event.key === 'Enter' && SearchItems() }} />
                        </div>
                    </div>
                    {/* <div className="col-1 mt-2">
                        {!DisableRecover &&
                            <div className="input-group m-2">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold">Casco</span>
                                </div>
                                <select
                                    value={handedCasco}
                                    onChange={({ target: { value } }) => validateCasco(Number(value))}
                                    className="form-control">
                                    <option value={0}> No </option>
                                    <option value={1}> Si </option>
                                </select>
                            </div>
                        }
                    </div> */}
                    <div className="col-3 mt-2 pr-4 ml-auto">
                        <div className='text-right'>
                            {Sections['CO1UserFields'] &&
                                <button
                                    className="btn btn-primary mt-2 mr-2 "
                                    style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}
                                    onClick={this.props.ShowCO1UserFields} >
                                    <i className="fa fa-list" aria-hidden="true"></i>
                                </button>
                            }
                            {Modules['TrackingOne'] &&
                                <button
                                    className="btn btn-primary mt-2 mr-2 "
                                    // data-toggle="modal"
                                    // data-target="#clientsModal"
                                    // disabled={DisableRecoverQT === true ? DisableRecoverQT : DisableRecover}
                                    style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}
                                    onClick={this.props.ShowSetDeliveries} >
                                    <i className="fa fa-truck" aria-hidden="true"></i>
                                </button>
                            }

                            <button
                                className="btn btn-primary mt-2"
                                data-toggle="modal"
                                data-target="#clientsModal"
                                disabled={DisableRecoverQT === true ? DisableRecoverQT : DisableRecover}
                                style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}
                                onClick={EnableClientsModal}>
                                <i className="fa fa-address-book-o" aria-hidden="true"></i>
                            </button>

                            {/* <span className=" ml-4 pr-4"><strong>{newOrderModel.CardName || _user?.Partner.CardName}</strong></span> */}
                            <div className='ml-4 pr-4 text-center' style={{ display: "inline-table" }}>
                                <span className="d-block" style={{ right: "50px", maxWidth: 270 }}><strong>{newOrderModel.CardCode || _user?.Partner?.CardCode} - {(newOrderModel.CardName !== null && newOrderModel.CardName !== undefined && newOrderModel.CardName !== '') ? newOrderModel.CardName.substring(0, 25) : '' || ((_user?.Partner && _user?.Partner?.CardName && _user?.Partner?.CardName !== null && _user?.Partner?.CardName !== undefined) && _user?.Partner?.CardName.substring(0, 25))}</strong></span>
                                {/* <div className='d-block' style={{ marginTop: "-10px" }}>
                                    <select
                                        className="text-center cursor-pointer"
                                        disabled={DisableRecover}
                                        style={{
                                            backgroundColor: "white",
                                            color: "#343a40", border: "none", fontSize: 12
                                        }}
                                        value={newOrderModel.PriceListNum}
                                        onChange={(event) => { ChangePriceList(event.target.value) }}>
                                        {_user?.PriceList.map((price, index) => <option key={`plCounter-${index}`} value={price.ListNum}> {price.ListName} </option>)}
                                    </select>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* BOTONES*/}
                <div className="footer-fmb">
                    <div className="row">
                        <div className=" col-8" style={{ bottom: "55px", position: "fixed", left: "1rem" }}>
                            <div className="row">
                                {itemsDashboard['counterReturns'] && itemsDashboard['counterReturns'].active &&
                                    <div className="card col-2 ml-2" style={CounterRol === 'counter' || CounterRol === 'storer' ? { opacity: "0.5" } : {}} data-toggle="modal" data-target="#refundModal" onClick={() => this.openLink("/counterReturns")} >
                                        <h3 className="card-title-pos  text-center">
                                            Devolución y/o Cancelaciones <span id="bdgMonAlt" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                                        </h3>
                                        <hr className="hr-pos" />
                                        <div className="text-center">
                                            <img src={require('../images/ico/devolu.png')} className="img-fluid icon-menu-dashboard" style={{ maxWidth: "59%", padding: "6px", marginTop: "4px" }} alt="" />
                                        </div>
                                    </div>
                                }

                                <div className="card col-2 ml-2" style={CounterRol === 'counter' || CounterRol === 'storer' ? { opacity: "0.5" } : {}} data-toggle="modal" onClick={DisableRecover ? () => { } : CounterRol === 'counter' || CounterRol === 'storer' ? "" : () => GetMovementsCash(1)}>
                                    <h3 className="card-title-pos  text-center">
                                        Entradas y retiros <span id="bdgMonAlt" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                                    </h3>
                                    <hr className="hr-pos" />
                                    <div className="text-center">
                                        <img src={require('../images/ico/retiro.png')} className="img-fluid icon-menu-dashboard" style={{ maxWidth: "59%", marginTop: "5px" }} alt="" />
                                    </div>
                                </div>

                                <div className="card col-2 ml-2" onClick={DisableRecover ? () => { } : ShowCashCutModal}>
                                    <h3 className="card-title-pos  text-center">
                                        Corte <span id="bdgMonAlt" className="badge badge-pill badge-info ml-2 dash-badge"></span>
                                    </h3>
                                    <hr className="hr-pos" />
                                    <div className="text-center">
                                        <img src={require('../images/ico/corteC.png')} className="img-fluid icon-menu-dashboard" style={{ maxWidth: "57%", marginTop: "3px" }} alt="" />
                                    </div>
                                </div>

                                <div className="card col-2 ml-2" style={CounterRol === 'storer' ? { opacity: "0.5" } : {}} data-toggle="modal" data-target="#savedSalesModal" onClick={DisableRecover ? () => { } : CounterRol === 'storer' ? '' : ShowSavedSalesModal}>
                                    <h3 className="card-title-pos  text-center">
                                        Recuperar <span id="bdgMonAlt" className="badge badge-pill badge-info ml-2 dash-badge" ></span>
                                    </h3>
                                    <hr className="hr-pos" />
                                    <div className="text-center">
                                        <img src={require('../images/ico/devo.png')} className="img-fluid icon-menu-dashboard" style={{ maxWidth: "59%", marginTop: "5px" }} alt="" />
                                    </div>
                                </div>

                                <div
                                    className="card ml-2 p-2 d-flex flex-column justify-content-center"
                                    style={{
                                        width: "140px",
                                        minWidth: "140px",
                                        backgroundColor: printerConnected ? "#d4edda" : "#f8d7da",
                                        border: `2px solid ${printerConnected ? "#28a745" : "#dc3545"}`,
                                        transition: "background-color 0.2s ease, border-color 0.2s ease"
                                    }}
                                >
                                    <div className="text-center mb-2" style={{ fontSize: 12, fontWeight: "bold" }}>
                                        <i className="fa fa-print mr-1" aria-hidden="true" />
                                        Impresora
                                    </div>
                                    <div
                                        className="text-center mb-2"
                                        style={{
                                            color: printerConnected ? "#155724" : "#721c24",
                                            fontSize: 11,
                                            fontWeight: "bold"
                                        }}
                                    >
                                        <i
                                            className={`fa ${printerConnected ? "fa-check-circle" : "fa-times-circle"} mr-1`}
                                            aria-hidden="true"
                                        />
                                        {printerConnected ? "Conectada" : "No conectada"}
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm mb-2"
                                        style={{ fontSize: 11 }}
                                        onClick={ReprintLastTicket}
                                    >
                                        <i className="fa fa-repeat mr-1" aria-hidden="true" />
                                        Reimprimir ultimo ticket
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        style={{ fontSize: 11 }}
                                        onClick={ShowPrinterConfiguration}
                                    >
                                        <i className="fa fa-cog mr-1" aria-hidden="true" />
                                        Configurar
                                    </button>
                                </div>

                                {/* <div className="card col-2 ml-2" style={CounterRol === 'counter' ? { opacity: "0.5" } : {}} data-toggle="modal" data-target="#deliverModal" onClick={CounterRol === 'counter' ? "" : ShowDeliverModal}>
                                    <h3 className="card-title-pos  text-center">
                                        Entregar<span id="bdgMonAlt" className="badge badge-pill badge-info ml-2 dash-badge" ></span>
                                    </h3>
                                    <hr className="hr-pos" />
                                    <div className="text-center">
                                        <img src={require('../images/ico/entregas.png')} className="img-fluid icon-menu-dashboard" style={{ maxWidth: "59%", marginTop: "5px" }} alt="" />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {/* TOTAL Y COBRAR */}
                        <div className="col-4" style={{ bottom: "55px", position: "fixed", left: "66%" }}>
                            <div
                                className="card ml-2 text-right"
                                style={{ background: "#d5f7d9", minHeight: "7vh" }}
                                data-toggle="modal"
                                data-target={(!DisableRecover && globalTax && EditTaxCode) ? "#taxesModal" : ""}
                                onClick={(DisableRecover || !globalTax) ? undefined : ShowTaxesModal}
                                onMouseEnter={() => this.setState({ showPerception: true })}
                                onMouseLeave={() => this.setState({ showPerception: false })}
                            >
                                {globalTax && <button disabled={DisableRecover} style={{ backgroundColor: "white", color: "#343a40", border: "none", fontSize: 12 }}>{newOrderModel.TaxName}</button>}
                                {showPerception && Number(newOrderModel?.U_BPP_TtPc) > 0 && (
                                    <>
                                        <h5 className="mr-2" style={{ color: "rgb(76 123 76)" }}>
                                            {`Subt.: ${CURRENCY} ${FORMAT_NUMBER.new(newOrderModel.auxTotal)}`}
                                        </h5>
                                        <h5 className="mr-2" style={{ color: "rgb(76 123 76)" }}>
                                            {`Perc.: ${CURRENCY} ${FORMAT_NUMBER.new(newOrderModel.U_BPP_TtPc)}`}
                                        </h5>
                                    </>
                                )}
                                {newOrderModel.IsCredit ?
                                    <h1 className="mr-2" style={newOrderModel.Total < 100000000 ? { fontSize: "3vw", color: "rgb(76 123 76)" } : { fontSize: "2.3vw", color: "rgb(76 123 76)" }}>{`${CURRENCY} ${FORMAT_NUMBER.new(newOrderModel.Credit - newOrderModel.Total)}`}</h1>
                                    :
                                    !isNaN(newOrderModel.Total) ?
                                        <h1 className="mr-2" style={newOrderModel.Total < 100000000 ? { fontSize: "3vw", color: "rgb(76 123 76)" } : { fontSize: "2.3vw", color: "rgb(76 123 76)" }}>{`${CURRENCY} ${FORMAT_NUMBER.new(newOrderModel.Total)}`}</h1>
                                        :
                                        <h1 className="mr-2" style={{ fontSize: "3vw", color: "rgb(76 123 76)" }}>{`${CURRENCY} ---`}</h1>
                                }
                            </div>
                            <div className="ml-2 mt-2">
                                <div className='row'>
                                    <div className='col-3' style={{ display: "inline-block", paddingRight: "5px" }}>
                                        <div className='row'>
                                            <div className='col-md-6' style={{ display: "inline-block", paddingRight: "0" }}>

                                                <button className="btn-lg btn-block btn-deleteAll" style={{ width: "100%" }} data-toggle="modal" data-target="#vmDeleteAll" onClick={() => ShowDeleteAll()}>
                                                    <i className="fa fa-trash-o" />
                                                </button>
                                            </div>

                                            <div className='col-md-6' style={{ display: "inline-block" }}>

                                                <button className="btn-lg btn-block btn-terminal" style={{ width: "100%" }} data-toggle="modal" data-target="#vmDeleteAll" onClick={() => CheckTerminalConnection()}>

                                                    <i className="fa fa-credit-card-alt" />
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                    {(newOrderModel.ObjType === 'deliveries') &&
                                        <div className='col-9 input-group' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            {newOrderModel.Credit > 0 ?
                                                <div className="input-group-prepend">
                                                    <button className="btn btn-credit" type="button" style={{ borderRight: "none" }}>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="checkbox" checked={newOrderModel.IsCredit} id="creditCheck" onChange={ChangeCreditCheck} />
                                                            <label className="form-check-label" for="defaultCheck1">
                                                                <i className="fa fa-credit-card-alt" aria-hidden="true"></i>
                                                            </label>
                                                        </div>
                                                    </button>
                                                    <button className="btn btn-lg btn-block btn-credit" data-toggle="modal" style={{ borderLeft: "none", borderRadius: "0.25rem" }} onClick={() => CheckIfItems(SendInvoiceValidation)}>Cobrar</button>
                                                </div>
                                                :
                                                <button className="btn-lg btn-block btn-cobrar" data-toggle="modal" onClick={() => CheckIfItems(SendInvoiceValidation)}>Cobrar</button>
                                            }
                                        </div>
                                    }
                                    {newOrderModel.ObjType === 'deliveries2' &&
                                        <div className='col-9' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            <button className="btn-lg btn-block btn-cobrar" data-toggle="modal" onClick={() => CheckIfItems(ValidateBusinessPartner)}>Venta a domicilio</button>
                                        </div>
                                    }
                                    {newOrderModel.ObjType === 'quotations' &&
                                        <div className='col-9' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            <button
                                                className="btn-lg btn-block btn-cobrar"
                                                data-toggle="modal"
                                                onClick={() => CheckIfItems(ShowVMQuotation)}
                                            >
                                                {`${recoveredQuoteOperation !== 1 ? "Generar" : "Actualizar"} Cotización`}
                                            </button>
                                        </div>
                                    }
                                    {newOrderModel.ObjType === 'orderSales' &&
                                        <div className='col-9' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            <button className="btn-lg btn-block btn-cobrar" data-toggle="modal" onClick={() => CheckIfItems(OrderValidation)} >Generar Pedido</button>
                                        </div>
                                    }
                                    {newOrderModel.ObjType === 'deliveries4' &&
                                        <div className='col-9' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            <button className="btn-lg btn-block btn-cobrar" data-toggle="modal" onClick={() => CheckIfItems(ShowRefSaleModal)}>Enviar a Caja</button>
                                        </div>
                                    }
                                    {newOrderModel.ObjType === 'invoiceReserve' &&
                                        <div className='col-9' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            <button className="btn-lg btn-block btn-cobrar" data-toggle="modal" /*data-target="#formatInvoiceModal"*/ onClick={() => CheckIfItems(SendReserveInvoice)}>Generar la Factura</button>
                                        </div>
                                    }
                                    {newOrderModel.ObjType === 'directDelivery' &&
                                        <div className='col-9' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            <button className="btn-lg btn-block btn-cobrar" data-toggle="modal" onClick={GetReportSalesPayments}>Entregar</button>
                                        </div>
                                    }
                                    {newOrderModel.ObjType === 'downPayments' &&
                                        <div className='col-9' style={{ display: "inline-block", paddingLeft: "3px" }}>
                                            <button className="btn-lg btn-block btn-cobrar" onClick={() => CheckIfItems(ShowAdvancePayment)}>Factura anticipo</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FOOTER */}
                    <div className="text-footer text-muted">
                        <div className='row'>
                            <div className='col-3 text-left'>
                                <label>{`SUC.:${_user?.Sucursal || 'Sin nombre'} ALM:${_user?.Branch?.AccountDefault?.length > 0 ? decodeText(_user?.Branch?.AccountDefault[0]?.WhsName) : 'Sin almacén'}`}</label>
                            </div>
                            <div className='col-6'>
                                <a href="https://fmbsolutions.mx/" className="text-muted" target="_blank" rel="noopener noreferrer">®FMB-Solutions  </a>- Todos los Derechos Reservados V{currentVersion}
                            </div>
                            <div className='col-3'>
                                <label className='pl-5'>{`${moment().format('MMMM Do YYYY, h:mm:ss a')}`}</label>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );
    }
}

export default NavBarCashier;
